import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Cog, LogOut, MessageCircle, Plus, User } from "lucide-react";

export const UserDropdown = ({ onLogout }) => {
  const { getUsername, getUserAvatar } = useAuth();
  const userName = getUsername();
  const userAvatar = getUserAvatar();

  // Get user initials for avatar
  const getUserInitials = () => {
    if (!userName) return "U";
    return userName.charAt(0).toUpperCase();
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="p-0 h-auto hover:bg-transparent">
          <Avatar className="h-9 w-9 border-2 border-igbanwo-mint/20">
            {userAvatar ? (
              <AvatarImage src={userAvatar} alt={userName || "User"} />
            ) : (
              <AvatarFallback className="bg-igbanwo-mint/10 text-igbanwo-mint">
                {getUserInitials()}
              </AvatarFallback>
            )}
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem asChild>
          <Link to="/profile" className="flex items-center cursor-pointer">
            <User className="w-4 h-4 mr-2" />
            Profile
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Link
            to="/create-listing"
            className="flex items-center cursor-pointer"
          >
            <Plus className="w-4 h-4 mr-2"/>
            Create Listing
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Link
            to="/messages"
            className="flex items-center cursor-pointer"
          >
            <MessageCircle className="w-4 h-4 mr-2"/>
            Messages
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Link
            to="/settings"
            className="flex items-center cursor-pointer"
          >
            <Cog className="w-4 h-4 mr-2"/>
            Settings
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={onLogout}
          className="text-red-500 hover:text-red-600 cursor-pointer"
        >
          <LogOut className="w-4 h-4 mr-2" />
          Sign Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
